<template>
    <div class="c-m-success-state">
        <div class="c-m-success-state__inner u-padding-horizontal-4">
            <p class="c-m-success-state__heading">{{heading}}</p>
            <div v-if="body" class="c-m-success-state__body" v-html="body"></div>
            <div class="c-m-success-state__action">
                <button-link v-if="button && button.to" :modifiers="button.classes" :link="button.to" :label="button.label" :icon="button.icon"></button-link>
                <button-function v-else-if="button && button.function" :modifiers="button.classes" @buttonClicked="button.function(...[button.functionArguments])" :label="button.label" :icon="button.icon"></button-function>
            </div>
        </div>
    </div>
</template>

<script>
    import Icon from '../atoms/AtomIcon.vue';
    import ButtonLink from '../atoms/AtomButtonLink.vue';
    import ButtonFunction from '../atoms/AtomButton.vue';

    export default {
        props: {
            heading: {
                type: String,
                default: 'Hurra!'
            },
            body: {
                type: String,
                default: '<p>Det gick ju strålande.</p>'
            },
            icon: {
                type: String,
                default: 'sentiment_very_satisfied'
            },
            button: {
                type: Object,
                default: function() {
                    return {}
                }
            }
        },
        components: {
            Icon,
            ButtonLink,
            ButtonFunction
        },
        created(){
            if(this.$ga){
                this.$ga.event({
                    eventCategory: 'Förfrågan klar',
                    eventAction: 'Tacksida',
                    eventLabel: '',
                    eventValue: 1
                });
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/views/components/molecules/MoleculeSuccessState.vue